import React from 'react';

import { Box, Typography, IconButton, Checkbox } from '@mui/material';

import { ReactComponent as HelpIcon } from '../../../../../common/assets/icons/help_icon.svg';
import { Modifier } from '../../../../types/Modifier';

import ModifierPopupInfo from './ModifierPopupInfo';

type Props = {
  modifier: Modifier;
  handleSelection: (modifier: Modifier, checked: boolean) => void;
};

const ModifierPopupCell: React.FC<Props> = ({ modifier, handleSelection }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleInfoClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '345px',
        mt: '15px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Checkbox
          sx={{
            mt: '-8px',
            alignSelf: 'flex-start',
            color: 'primary',
          }}
          inputProps={{ 'aria-label': 'controlled' }}
          checked={modifier.selected}
          onChange={(
            event: React.ChangeEvent<HTMLInputElement>,
            checked: boolean
          ) => handleSelection(modifier, checked)}
        />
        <Typography
          fontFamily='SFProDisplay-Semibold'
          sx={{
            display: 'flex',
            flexDirection: 'row',
            whiteSpace: 'break-spaces',
            textAlign: 'left',
          }}
        >
          {modifier.cptModifier + '. '}
          <span
            style={{ color: '#00214580', fontFamily: 'SFProDisplay-Medium' }}
          >
            {modifier.name}
          </span>
        </Typography>
      </Box>

      {(modifier.definition ||
        modifier.summary ||
        modifier.examples ||
        modifier.rules) && (
        <>
          <IconButton onClick={handleInfoClick}>
            <HelpIcon />
          </IconButton>
          <ModifierPopupInfo
            modifier={modifier}
            anchorEl={anchorEl}
            open={open}
            id={id}
            handleClose={handleClose}
          />
        </>
      )}
    </Box>
  );
};

export default ModifierPopupCell;
